const NS = 'WysiwygContainerBlock';
const CLS = 'wysiwygContainerBlock';

export class WysiwygBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.initImageOverride();
		this.initResponsiveTables();
	}

	initImageOverride() {
		this.$images = this.$element.find('img');

		this.$images.each((index, element) => {
			// Float left property
			if($(element).css('float') === 'left') {
				$(element).addClass('float-left');
			}
			// Float right
			else if($(element).css('float') === 'right') {
				$(element).addClass('float-right');
			}
			// Align center (block implies center block alignment)
			else if($(element).css('display') == 'block') {
				$(element).addClass('align-center');
			}
		});
	}

	// Adds the table--responsive class depending on the width of the table and the wysiwygBlock
	initResponsiveTables() {
		this.$tables = this.$element.find('table');
		let adjustTableClass = () => {
			this.$tables.each((index, element) => {
				let $element = $(element);
				if($element.width() > this.$element.width()) {
					$element.addClass('table--responsive');
				}
			});
		};

		$(window).resize(_.debounce(() => {
			adjustTableClass();
		}, 250));

		adjustTableClass();
	}
}
